import { useEffect } from 'react';
import { createSessionKey } from '../services/accountAbstractionService';
import { setSessionKey, setSessionStorageClient } from '../store/accountAbstractionActions';
import { useAccountAbstractionDispatch, useAccountAbstractionStore } from '../store/AccountAbstractionContext';
import config from '@/common/config';

export const useSessionKeyAndStorageClient = () => {
  const dispatch = useAccountAbstractionDispatch();
  const accountAbstractionStore = useAccountAbstractionStore();

  const { smartAccount, sessionKeyAddress, sessionStorageClient } = accountAbstractionStore?.state;

  useEffect(() => {
    const createSessionKeyAndStorageClient = async () => {
      if (!config.smartWalletEnabled) return;

      if (smartAccount && !sessionKeyAddress && !sessionStorageClient) {
        const { sessionKeyAddress: newSessionKeyAddress, sessionStorageClient: newSessionStorageClient } =
          await createSessionKey(smartAccount);
        dispatch(setSessionKey(newSessionKeyAddress));
        dispatch(setSessionStorageClient(newSessionStorageClient));
      }
    };
    createSessionKeyAndStorageClient();
  }, [smartAccount, sessionKeyAddress, sessionStorageClient, dispatch]);
};
